import HeaderEmbed from '@common/HeaderEmbed'
import '@common/reset.css'
import './style.scss'
import { Activity, useEffect, useState } from 'react'
import Home from './components/Home'
import Noticia from './components/Noticia'

export default function App({ lang, preview, embedHome }) {
	const [premis, setPremis] = useState(null)

	useEffect(() => {
		fetch(`${process.env.API_CLIENT}/embeds/v1/la-grossa`)
			.then((res) => res.json())
			.then((json) => setPremis(json.data))
			.catch((error) => console.log(error))
	}, [])

	if (!premis) return null

	const taulesPremis = [
		{
			title: 'PRIMER PREMI',
			key: 'primer_premi',
			import: [
				['20.000€', '200.000€'],
				['200€', '2.000€'],
				['200€', '2.000€'],
				['100€', '1.000€'],
				['25€', '250€'],
				['3.5€', '35€'],
				['1€', '10€'],
			],
			includeLastDigit: true,
		},
		{
			title: 'SEGON PREMI',
			key: 'segon_premi',
			import: [
				['6.500€', '65.000€'],
				['65€', '650€'],
				['65€', '650€'],
				['30€', '300€'],
				['7.5€', '75€'],
				['2.5€', '25€'],
			],
		},
		{
			title: 'TERCER PREMI',
			key: 'tercer_premi',
			import: [
				['3.000€', '30.000€'],
				['50€', '500€'],
				['50€', '500€'],
				['20€', '200€'],
				['3.5€', '35€'],
				['2€', '20€'],
			],
		},
		{
			title: 'QUART PREMI',
			key: 'quart_premi1',
			import: [
				['1.000€', '10.000€'],
				['20€', '200€'],
				['20€', '200€'],
				['10€', '100€'],
				['3€', '30€'],
				['1.5€', '15€'],
			],
		},
		{
			title: 'QUART PREMI',
			key: 'quart_premi2',
			import: [
				['1.000€', '10.000€'],
				['20€', '200€'],
				['20€', '200€'],
				['10€', '100€'],
				['3€', '30€'],
				['1.5€', '15€'],
			],
		},
		{
			title: 'CINQUÈ PREMI',
			key: 'cinque_premi1',
			import: [
				['500€', '5.000€'],
				['15€', '150€'],
				['15€', '150€'],
				['7.5€', '75€'],
				['2.5€', '25€'],
				['1€', '10€'],
			],
		},
		{
			title: 'CINQUÈ PREMI',
			key: 'cinque_premi2',
			import: [
				['500€', '5.000€'],
				['15€', '150€'],
				['15€', '150€'],
				['7.5€', '75€'],
				['2.5€', '25€'],
				['1€', '10€'],
			],
		},
		{
			title: 'CINQUÈ PREMI',
			key: 'cinque_premi3',
			import: [
				['500€', '5.000€'],
				['15€', '150€'],
				['15€', '150€'],
				['7.5€', '75€'],
				['2.5€', '25€'],
				['1€', '10€'],
			],
		},
	]

	return (
		<>
			<Activity mode={preview ? 'visible' : 'hidden'}>
				<HeaderEmbed allowHomeEmbed />
			</Activity>
			<div className='content'>
				<Home premis={premis} embedHome={embedHome} />
				<Activity mode={embedHome ? 'hidden' : 'visible'}>
					<Noticia taulesPremis={taulesPremis} premis={premis} />
				</Activity>
			</div>
		</>
	)
}
